import { render, staticRenderFns } from "./SelectionList.vue?vue&type=template&id=23241b45"
import script from "./SelectionList.vue?vue&type=script&lang=js"
export * from "./SelectionList.vue?vue&type=script&lang=js"
import style0 from "./SelectionList.vue?vue&type=style&index=0&id=23241b45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports